<template>
  <div class="container-fluid">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-7">
        <img id="logo-orisha" class="d-block"
             src="https://medias.bimedia-it.com/assets/logo_orisha_rs_blanc.svg"/>
        <div class="card card-orisha">
          <div class="card-header">
            <h1 class="text-center my-1 col-10 mx-auto title-balanced">
              Réinitialisation de mot de passe
            </h1>
          </div>
          <div class="card-body">
            <p class="text-center dev-text-spacing">
              Merci d'entrer votre nouveau mot de passe pour l'identifiant
              <b>{{ name }}</b>
            </p>
            <RecoveryForm :license="license" :name="name"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import RecoveryForm from '../components/form/RecoveryForm.vue';

export default {
  name: 'Recovery',
  data() {
    return {
      // Token de vérification
      token: this.$route.query.token,
      license: undefined,
      name: undefined,
      source: undefined,
    };
  },
  created() {
    axios.post('/auth/api/front/token', JSON.stringify({
      token: this.token,
    }), { headers: { 'content-type': 'application/json' } })
      .then((res) => {
        this.license = res.data.user.license;
        this.name = res.data.user.username;
        this.source = res.data.source;
      })
      .catch(() => {
        this.$router.push({ name: 'Error', params: { errorType: 'token' } });
      });
  },
  components: {
    RecoveryForm,
  },
};
</script>

<style scoped>
.title-balanced {
  text-wrap: balance;
}
</style>
